import { useMutation } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { LogisticPivotApiAdapter } from '../adapters/LogisticPivotApiAdapter';
import type { LogisticPivotQuery } from '../models/LogisticPivot';

const httpClient = createHttpClient(apiClientWH);
const adapter = new LogisticPivotApiAdapter(httpClient);

export const useExportLogisticPivot = () =>
  useMutation({
    mutationFn: async (query: LogisticPivotQuery | undefined) => {
      const { url_file } = await adapter.exportLogisticPivotExcel(query);
      return url_file;
    },
  });
